import { render } from "./PriceInput.vue?vue&type=template&id=1ad7fa39&ts=true"
import script from "./PriceInput.vue?vue&type=script&lang=ts"
export * from "./PriceInput.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__